var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"widget-body-container"},[(_vm.properties.pending)?[_vm._m(0)]:[_c(_vm.WidgetType,{tag:"component",attrs:{"properties":_vm.properties}})]],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widget-loader-wrapper"},[_c('span',{staticClass:"g-radial-loader"})])
}]

export { render, staticRenderFns }